export const FETCH_PRODUCTS_AND_SITES = "FETCH_PRODUCTS_AND_SITES";
export const FETCH_DATA = "FETCH_DATA";
export const GENERATE_KPI_TABLE = "GENERATE_KPI_TABLE";
export const GENERATE_KPI_GRAPH = "GENERATE_KPI_GRAPH";
export const FETCH_DASHBOARD_FILTERED_BATCH_LIST =
  "FETCH_DASHBOARD_FILTERED_BATCH_LIST";
export const FETCH_TABLE_PLOT_STATE = "FETCH_TABLE_PLOT_STATE";
export const SET_SELECTED_BATCH_IDS = "SET_SELECTED_BATCH_IDS";
